module.exports = __webpack_public_path__ + "img/skale-small-light.d335517d.svg";